import React from "react";
import { Info } from "lucide-react";

/**
 * Shared placeholder page for the 12 non-functional Atlas nav items.
 * Renders inside the AtlasLayout shell (right of AtlasNav, below
 * AtlasHeader). Props:
 *   - title: string
 *   - description: string
 *   - icon: lucide component (defaults to Info)
 *   - testId: string (used for data-testid on the page root)
 */
export default function AtlasComingSoonPage({
  title,
  description,
  icon: Icon = Info,
  testId,
}) {
  const dtid = testId || `atlas-placeholder-${(title || "coming-soon").toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <div className="p-6 md:p-10 max-w-5xl" data-testid={dtid}>
      <h1
        className="text-tb-navy text-3xl md:text-4xl font-semibold"
        style={{ fontFamily: '"Playfair Display", serif' }}
      >
        {title}
      </h1>
      <p className="mt-1 font-hand text-tb-navy/60 text-sm">
        {description}
      </p>

      <div className="mt-8 rounded-2xl border border-tb-navy/15 bg-white p-10 md:p-14 max-w-2xl">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-full border border-tb-navy/20 flex items-center justify-center text-tb-navy/50 shrink-0">
            <Icon className="w-5 h-5" strokeWidth={1.6} />
          </div>
          <div className="flex-1">
            <div
              className="text-tb-navy text-xl font-semibold"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Coming in a future slice
            </div>
            <p className="mt-1.5 font-hand text-tb-navy/65 text-sm leading-relaxed max-w-md">
              This surface is scaffolded and reachable — the interactive
              tooling ships in a later Atlas phase. Your role permissions,
              wallet balance, and knowledge contributions carry over unchanged.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
